import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { deleteAdminEmployerRoute } from '../api/constant';
import { adminEmployersList, adminEnterprisesList, blockAccountList, spamAccountList } from '../constants';

type useDeleteEmployerProps = {
    setAlertText?: Dispatch<SetStateAction<string>>;
};

export const useDeleteEmployer = ({
    setAlertText = () => { },
}: useDeleteEmployerProps) => {
    const client = useQueryClient();

    const { mutate: deleteEmployer, isLoading: isdeleteEmployerLoading } =
        useMutation({
            mutationFn: (variables: {
                user_id: number | string;
            }) =>
                axiosInstance
                    .post(deleteAdminEmployerRoute, variables, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    })
                    .then((res) => res.data),
            onSuccess: (data) => {
                client.invalidateQueries(adminEmployersList);
                client.invalidateQueries(adminEnterprisesList);
                client.invalidateQueries(spamAccountList);
                client.invalidateQueries(blockAccountList);
                setAlertText('');
            },
            onError: () => {
                setAlertText(errorMessage);
            },
        });
    return {
        deleteEmployer,
        isdeleteEmployerLoading,
    };
};
